module.exports = __webpack_public_path__ + "img/trophy.3c26e1be.gif";